import { render, staticRenderFns } from "./suggest-budget.vue?vue&type=template&id=d19c63c8&scoped=true"
import script from "./suggest-budget.vue?vue&type=script&lang=js"
export * from "./suggest-budget.vue?vue&type=script&lang=js"
import style0 from "./suggest-budget.vue?vue&type=style&index=0&id=d19c63c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19c63c8",
  null
  
)

export default component.exports